import SubHeader from "./fragments/SubHeader";
import 'bootstrap/dist/css/bootstrap.min.css';
import POList from "./fragments/POList";
import {useDispatch, useSelector} from "react-redux";
import {searchPo, selectPo} from "../../redux/slices/purchassingOrder";
import React, {useMemo, useState} from "react";
import {FILTER_INITIAL_STATE} from "./constants";
import InfinityScroll from "../../shared/components/InfinityScroll";
import LoadMoreSpinner from './../../shared/components/LoadMoreSpinner';
import { STATUS_PENDING } from './../../constants';
import {Col} from "antd";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import Divider from "@material-ui/core/Divider";
import DirectionsIcon from "@material-ui/icons/Directions";
import {makeStyles} from "@material-ui/core/styles";
import {useForm} from "react-hook-form";

let isInitialized = false;
const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
        color: 'white'
    },
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
}));

export default function PurchaseOrder() {
    const [filter, setFilter] = useState(FILTER_INITIAL_STATE)

    const {list, noResult, status } = useSelector(selectPo);

    const dispatch = useDispatch();
    const classes = useStyles();
    const [filtered, setFiltered] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const { register, handleSubmit } = useForm();


    const totalCost = useMemo(() => {
        let total = 0;
        list?.forEach( PO =>{
            if(PO?.Currency !== "FCFA" || PO?.Currency === null){
                PO.Purchases.forEach(e =>
                    {
                        total += e.Amount
                    })
            }
        })
        return total;

    }, [list])
   
    const totalCostFCFA = useMemo(() => {

        let total = 0; 
        return total;

    }, [list])
   

    const nbPos = useMemo(() => {
        return !list ? 0 : list.length;
    }, [list])

    if (!isInitialized) {
        isInitialized = true;
        dispatch(searchPo({}));
    }

    const handleFilterChange = (filter) => {
        dispatch(searchPo({filter: filter}))
        setFilter(filter)
    }

    const handleLoadMore = () => dispatch(searchPo({filter: filter}))
    console.log( "hjhjh" , list)
    // console.log( "ooooo" , list[0])
    // console.log( "iiii" , list[0].id)
    // console.log( "ffff" , list[0].Purchases)
    // console.log("LIst"+JSON.stringify(list[0]))
    // console.log("LIst ze "+JSON.stringify(list[0].Purchases))
    // console.log(nbPos)
    // console.log(totalCost)

    function handleSearch({ keyword }) {
        let segments = keyword.split(' ');

        let filtered = [];
        for (const segment of segments) {
            const found = list.filter(order => {
                return order.Purchases.some(item => {
                    return item?.Name?.toLowerCase().includes(segment.toLowerCase())
                        || item?.InternalId?.toLowerCase().includes(segment.toLowerCase())
                        || item?.Barcode?.toLowerCase().includes(segment.toLowerCase());
                });
            });

            found.forEach(order => {
                if (!filtered.find(one => one.id === order.id))
                    filtered.push(order);
            });
        }

        setFiltered(filtered)
        setIsSearching((segments.length > 0 && segments[0] !== ''))
    }
    const handleClearSearchBox = () => setIsSearching(false)




    return (
        <main>
            <SubHeader totalCost={totalCost} totalCostFCFA={totalCostFCFA} numberPOs={nbPos} onFilterChange={handleFilterChange}/>
            <Col item xs={9}>
                <Paper component="form" className={classes.root} onSubmit={handleSubmit(handleSearch)}>
                    <InputBase
                        className={classes.input}
                        placeholder="Search..z."
                        inputProps={{ 'aria-label': 'search...' }}
                        {...register('keyword')}
                        onChange={event => handleSearch({ keyword: event.target.value })}
                    />
                    <IconButton type="submit" className={classes.iconButton} aria-label="search">
                        <SearchIcon />
                    </IconButton>
                    <Divider className={classes.divider} orientation="vertical" />
                    <IconButton color="primary" type='reset' onClick={handleClearSearchBox}
                                className={classes.iconButton} aria-label="directions">
                        <DirectionsIcon />
                    </IconButton>
                </Paper>
            </Col>
            <div style={{height: 20}}/>
           {list && 
           <InfinityScroll data={isSearching ? filtered : list} hasMore={!noResult} loadMoreAction={handleLoadMore}>
                <POList items={isSearching ? filtered : list}/>
            </InfinityScroll>}

            {
                status === STATUS_PENDING &&
                <LoadMoreSpinner number={12} />
            }

        </main>
    )
}
